import { ActorDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.actor";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { useActorTableChangeVersion } from "@-/dev.improve.haniverse.lib.database.change.actor";
import { createUseQueryOptions } from "@-/dev.improve.haniverse.lib.query-options";

// The studied-grapheme set is derived from `user_card` + its meaning-card relation,
// so the key must be invalidated when either changes — otherwise the set goes stale
// after a card is added/removed. The predicate is derived from the read's `with`.
const STUDIED_GRAPHEMES_CONFIG = {
  columns: {},
  where: { fsrsCardId: { isNotNull: true } },
  with: { userGraphemeMeaningCard: { columns: { grapheme: true } } },
} as const;

export function useGetStudiedGraphemesQueryKey() {
  const [actorDb] = useContextSelectors(ActorDatabaseContext, (context) => context.db);
  const withTableChangeVersion = useActorTableChangeVersion("userCard", STUDIED_GRAPHEMES_CONFIG);
  return () => withTableChangeVersion(["studiedGraphemes", { actorDb }] as const);
}

export const [useStudiedGraphemesQueryOptions, studiedGraphemesQueryFn] = createUseQueryOptions(
  useGetStudiedGraphemesQueryKey,
  async ({ queryKey: [_, { actorDb }] }) => {
    // Soft-delete filter is injected by the wrapped `actorDb` query proxy.
    // Only the resulting set belongs in the cache, not a second copy of every card's mnemonic.
    const studyCards = await actorDb(import.meta.location).query.userCard.findMany(
      STUDIED_GRAPHEMES_CONFIG,
    );

    const studiedGraphemes = new Set<string>();
    for (const studyCard of studyCards) {
      const grapheme = studyCard.userGraphemeMeaningCard?.grapheme;
      if (grapheme !== undefined) {
        studiedGraphemes.add(grapheme);
      }
    }
    return studiedGraphemes;
  },
);
